import {useSelector} from "react-redux";
import {getDashboardTableData} from "../../../redux/Selectors/dashboard.selector";

export const useDashboardTableData = () => {
  const dashboardData = useSelector(getDashboardTableData);

  return {organizations: dashboardData?.organizations || []};
};
